<div class="w-100 h-100 loading-wrapper position-relative d-flex justify-content-center align-items-center">
    <div class="position-absolute custom-margin">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
